import React from 'react'
import { Col, Row, Space, Typography } from 'antd'
import ButtonGlobal from '@shared/Button'
import {
  AlertIconIntoDetail,
  AsanIco,
  DeleteIco,
  EditIco,
} from '@modules/CustomIcons'
import i18next from 'i18next'
import './style.scss'
import { useTranslation } from 'react-i18next'
import { IconButtonGroup } from '@shared/IconButtonGroup'
import { OnCloseModalType } from 'pages/Orders/types'
import {
  OrderType,
  StatusType,
} from 'pages/Orders/SalaryCardOrder/constants/fieldValues.constant'
import { secureLocalStorageGet } from '../../../../../../../helpers'
import { arrayBufferToBase64, AsanSigning } from '@shared/AsanSigning'
import DeleteOrderForm from './DeleteOrderForm'
import { IconButtonItemProps } from '@shared/IconButtonGroup/types'
import { useHistory } from 'react-router-dom'
import CustomAccordion from '../accardion/CustomAccordion'
import {
  businessCardOrderApi,
  useBusinessCardOrderDetailMutation,
  useUpdateBusinessCardOrderStatusMutation,
} from '@app/store/reducers/salaryCards/businessCardOrder.api'
import { useDispatch } from 'react-redux'
import useAsanAdocDownloader from '@shared/AsanSigning/useAsanAdocDownloader'
import { asanSigningAdocFile } from '@app/services/IbSigning/asan'

const OrderDetailModalFooter: React.FC<OnCloseModalType> = ({
  onCloseModal,
}) => {
  const role = secureLocalStorageGet('rol')
  const history = useHistory()
  const dispatch = useDispatch()

  const { downloadAdocFile } = useAsanAdocDownloader()

  const [updateOrderStatus, { status: upStatus, error, isSuccess }] =
    useUpdateBusinessCardOrderStatusMutation()

  const [_, { data: detailInformationList, isSuccess: isOdSuccess }] =
    useBusinessCardOrderDetailMutation({
      fixedCacheKey: 'businessCardOrderDetail',
    })
  const disabledCanditation = !(
    detailInformationList?.status === StatusType.PENDING_SIGNER
  )

   const disabledAdocConditation = !(
   [ StatusType.CLOSED,StatusType.BANK_EXECUTION,StatusType.CARD_READY,StatusType.CARD_RECEIVED].includes(detailInformationList?.status as StatusType)
  )

  const disabledSignBtn =
    detailInformationList?.status === StatusType.PENDING_SIGNER

  const { t } = useTranslation()

  const footerActionBtns: IconButtonItemProps[] = [
    {
      icon: <EditIco />,
      title: i18next.t('transfers.edit2'),
      key: 'edit',
      visible: false,
      disabled: disabledCanditation,
      onClick: () => {
        history.push(
          `/orders/business-card/update/${detailInformationList?.orderNo}`
        )
      },
    },
    {
      icon: <DeleteIco />,
      modal: {
        footer: null,
        title: t('orders.salaryCardOrder.constants.deleteReason'),
        width: 600,
        bodyStyle: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' },
        modalContent: (
          <DeleteOrderForm orderNo={detailInformationList?.orderNo} />
        ),
      },
      title: i18next.t('transfers.delete'),
      key: 'delete',
      visible: false,
      disabled: disabledCanditation,
      onClick: () => {},
    },
  ]

  const footerBtnsTransferFooter = [
    {
      icon: <AsanIco />,
      title: i18next.t('transfers.downloadAdoc'),
      key: 'adoc',
      visible: false,
      disabled: disabledAdocConditation,
      onClick: () => {
        downloadAdocFile(
          asanSigningAdocFile,
          detailInformationList?.transactionId,
          `${detailInformationList?.orderNo}.adoc`
        )
      },
    },
  ]

  const onSigning = async () => {
    try {
      if (isOdSuccess) {
        return {
          files: [
            {
              name: `${detailInformationList?.orderNo}.json`,
              mimeType: 'application/json',
              encodedBytes: arrayBufferToBase64(detailInformationList),
            },
          ],
        }
      }
    } catch (error) {
      console.log('🚀 ~ onSigning ~ error:', error)
    }
  }

  return (
    <>
      <Row>
        <CustomAccordion />
      </Row>
      <Row
        justify={'space-between'}
        align={'middle'}
        style={{ marginTop: '20px' }}
      >
        <Col span={16}>
          <Row style={{ width: '100%' }} gutter={20}>
            <Col>
              <IconButtonGroup buttons={footerActionBtns} />
            </Col>
            <Col>
              <IconButtonGroup buttons={footerBtnsTransferFooter} />
            </Col>
            {detailInformationList?.orderType === OrderType.URGENT && (
              <Row
                style={{
                  width: '350px',
                  padding: '12px',
                  borderRadius: '8px',
                  backgroundColor: '#F3F6FA',
                  fontSize: '10px',
                  fontWeight: 500,
                  display: 'flex',
                }}
              >
                <div style={{ marginRight: '8px' }}>
                  <AlertIconIntoDetail />
                </div>

                <Typography.Text>
                  {t('orders.salaryCardOrder.constants.commissionFee')}
                </Typography.Text>
              </Row>
            )}
          </Row>
        </Col>

        <Col>
          <Space>
            <ButtonGlobal
              size="large"
              color="#015CD1"
              customType="default"
              onClick={onCloseModal}
            >
              {t('common.close')}
            </ButtonGlobal>
            {role === 2 &&
              detailInformationList?.status === StatusType.PENDING_SIGNER && (
                <AsanSigning
                  docType="BCO"
                  asanKey="asanSignInDetail"
                  handleSigning={onSigning}
                  checkSignCallback={() => disabledSignBtn}
                  status={upStatus}
                  message={error?.data}
                  afterCloseFn={() => {
                    if (isSuccess) {
                      dispatch(
                        businessCardOrderApi.endpoints.businessCardOrderDetail.initiate(
                          { orderNo: detailInformationList?.orderNo },
                          { fixedCacheKey: 'fetchOrderDetails' }
                        )
                      )
                      dispatch(
                        businessCardOrderApi.util.invalidateTags([
                          'SalaryCardStatusList',
                        ])
                      )
                    }
                  }}
                  onComplete={(data) => {
                    updateOrderStatus({
                      orderNo: detailInformationList?.orderNo,
                      ...data,
                    })
                  }}
                />
              )}
          </Space>
        </Col>
      </Row>
    </>
  )
}

export default OrderDetailModalFooter
